import { createAsyncThunk } from "@reduxjs/toolkit";
import { customAxios } from "../../../utlis/authService";
import { errorMessage, successMessage } from "../../../utlis/common";
import { SOME_WENT_WRONG } from "../../../utlis/messages";

const GET_NOTIFICATIONS = `notifications`

export const GetNotifications = createAsyncThunk(
  "Notifications",
  async ({ page, limit, search = "" }: any, { rejectWithValue, dispatch, getState }) => {
    try {
      const user = localStorage.getItem("id")
      const response = await customAxios('application/json', dispatch).get(`${GET_NOTIFICATIONS}?page=${page}&limit=${limit}&search=${search}`);
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const DeleteNotification = createAsyncThunk(
  "DeleteNotification",
  async ({ id, selectedPage }: { id: string; selectedPage: any }, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).delete(`notifications/${id}`);
      successMessage("Notification deleted successfully");
      await dispatch(GetNotifications({ page: 1, limit: 10 }));

      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);

export const ClearAllNotification = createAsyncThunk(
  "ClearAllNotification",
  async (_, { rejectWithValue, dispatch, getState }) => {
    try {
      const response = await customAxios('application/json', dispatch).delete(`notifications`);
      successMessage("Notifications deleted successfully");
      await dispatch(GetNotifications({ page: 1, limit: 10 }));
      
      return response.data;
    } catch (error: any) {
      errorMessage(error?.response?.data?.error || SOME_WENT_WRONG)
      return rejectWithValue(error.response.data);
    }
  }
);
